import { render } from "./informacoes_gerais_molde.vue?vue&type=template&id=29f84ff2&scoped=true"
import script from "./informacoes_gerais_molde.vue?vue&type=script&lang=js"
export * from "./informacoes_gerais_molde.vue?vue&type=script&lang=js"

import "./informacoes_gerais_molde.vue?vue&type=style&index=0&id=29f84ff2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f84ff2"]])

export default __exports__